// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySearchPage from '../../components/CompanySearch/CompanySearch';

const ViewVehicleReport: React.FC = () => {
    return (
        <Entrypoint>
            <CompanySearchPage />
        </Entrypoint>
    );
}

export default ViewVehicleReport;